export const articles = {
  1: {
    title: 'Мир шоколада',
    descr: 'История, традиции <br/>и&nbsp;вдохновение',
    bg: '#E60000',
    items: [
      {
        type: 'Статья',
        time: '5 мин',
        title: 'История <br/>шоколада',
        image: 'article1.jpg',
        link: 'article/history',
        darkText: true
      },
      {
        type: 'Статья',
        time: '5 мин',
        title: 'ПЕРЕРАБОТКА КАКАО-БОБОВ',
        image: 'article2.webp',
        link: 'article/processing',
        notReady: true
      },
      {
        type: 'Статья',
        time: '5 мин',
        title: 'СОСТАВ <br/>ШОКОЛАДА',
        image: 'article3.jpg',
        link: 'article/contents',
        darkText: true,
        notReady: true
      },
      {
        type: 'Статья',
        time: '2 мин',
        title: 'ТИПЫ ШОКОЛАДА И&nbsp;НАЧИНОК',
        image: 'article4.webp',
        link: 'article/types',
        notReady: true
      },
    ]
  },
  2: {
    title: 'Путь какао',
    descr: 'От дерева какао до&nbsp;шоколадной плитки',
    bg: '#863F1E',
    items: [
      {
        type: 'Статья',
        time: '3 мин',
        title: 'История шоколада Nestlé',
        image: 'article5.webp',
        link: 'article/history_nestle',
        notReady: true
      },
      {
        type: 'Статья',
        time: '4 мин',
        title: 'ВЫРАЩИВАНИЕ КАКАО-БОБОВ',
        image: 'article6.webp',
        link: 'article/cultivation',
        darkText: true,
        notReady: true
      },
      {
        type: 'Статья',
        time: '7 мин',
        title: 'ЗАКУПКА КАКАО-БОБОВ',
        image: 'article7.webp',
        link: 'article/buy',
        notReady: true
      },
      /*{
        type: 'Статья',
        time: '4 мин',
        title: 'ПОВТОРЕНИЕ КЛЮЧЕВЫХ МАТЕРИАЛОВ',
        image: 'article8.jpg',
        link: 'article/materials',
        darkText: true
      },*/
    ]
  }
}
